export var InningHalfEnum;
(function (InningHalfEnum) {
    InningHalfEnum[InningHalfEnum["TOP"] = 0] = "TOP";
    InningHalfEnum[InningHalfEnum["BOTTOM"] = 1] = "BOTTOM";
})(InningHalfEnum || (InningHalfEnum = {}));
